/**
 * External Imports
 */
import { FC, useCallback } from 'react';
import { connect } from 'react-redux';

/**
 * Internal Imports
 */
import SupportListSettingsTable from './supportListSettingsTable/SupportListSettingsTable';
import { RootState } from '../../../../redux/store';
import {
  useGetEmployeeSubjectConfigQuery,
  useUpdateSubjectHiddenStatusMutation
} from '../../../../redux/apis/Users.api';

import { useFeatures } from '../../../../services/Features/features';
import { useUserRolesRef } from '../../../../services/UserRoles';

/**
 * GLobal Type Definition Imports
 */
import { ValidationEmployee } from '../../../../config/interfaces';

interface AIDETListSettingsProps {
  facilityId: string;
  userId: string;
}

const AIDETListSettingsTable: FC<AIDETListSettingsProps> = ({
  facilityId,
  userId
}) => {
  const {
    isEnterpriseAdmin,
    isNonSupportRounder,
    isTemplateConfigurator,
    isUserAdmin,
    isAidetValidationRounder
  } = useUserRolesRef();

  const { isAIDETValidationEnabled } = useFeatures();

  const {
    data: aidetValidationEmployeeData,
    // isError: isGetEmployeeSubjectConfigError,
    // isFetching: isGetEmployeeSubjectConfigFetching,
    isLoading: isGetEmployeeSubjectConfigLoading
  } = useGetEmployeeSubjectConfigQuery(
    // Need to adjust later when we know new validation rounding types
    { employeeId: userId, roundingType: 'aidetValidation' },
    {
      refetchOnMountOrArgChange: 15,
      skip: !isAIDETValidationEnabled || !userId
    }
  );
  const [
    updateSubjectHiddenStatus
    // {
    //   isError: isUpdateSubjectHiddenStatusError,
    //   isLoading: isUpdateSubjectHiddenStatusLoading,
    //   isSuccess: isUpdateSubjectHiddenStatusSuccess
    // }
  ] = useUpdateSubjectHiddenStatusMutation();

  const hideEmployee = useCallback(
    (employee: ValidationEmployee) => {
      updateSubjectHiddenStatus({
        employeeId: employee.hcaid,
        facilityId,
        roundingType: 'aidetValidation',
        userId,
        visible: !employee.visible
      });
    },
    [facilityId, userId]
  );

  return (
    <SupportListSettingsTable
      employees={aidetValidationEmployeeData}
      isFacilitySelectorEnabled={
        isEnterpriseAdmin ||
        (isAidetValidationRounder &&
          !(isNonSupportRounder || isTemplateConfigurator || isUserAdmin))
      }
      isTableEnabled={isAIDETValidationEnabled}
      loadingSupportList={isGetEmployeeSubjectConfigLoading}
      type="aidet"
      hideEmployee={hideEmployee}
    />
  );
};

const mapReduxStateToProps = (state: RootState) => {
  return {
    facilityId: state.AuthorizedUser.authorizedUser.facilityId,
    userId: state.AuthorizedUser.authorizedUser.hcaid
  };
};

export default connect(mapReduxStateToProps)(AIDETListSettingsTable);
